// import { useEffect, useState } from 'react';
// import Layout from '../layout/Layout';
// import PageTransition from '../components/PageTransition';
// import { getMessageLogs } from '../components/DbServices';

// export default function Reports() {
//   const [logs, setLogs] = useState([]);
//   const [loading, setLoading] = useState(true);
  
//   // PAGINATION STATE
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 5; // Change this to show more/less rows per page

//   const user = getStoredUser();
//   const userId = user?.data?.id;

//   useEffect(() => {
//     const fetchReports = async () => {
//       const res = await getMessageLogs(userId);
//       if (res.status === 200) setLogs(res.data);
//       setLoading(false);
//     };
//     fetchReports();
//   }, [userId]);

//   // LOGIC TO SLICE DATA
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = logs.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(logs.length / itemsPerPage);

//   const handleExport = () => {
//     Swal.fire("Generating CSV report...");
//   };

//   return (
//     <Layout>
//       <PageTransition>
//         <div className="d-flex justify-content-between align-items-center mb-4">
//           <div>
//             <h3 className="fw-bold mb-1">Message Reports</h3>
//             <p className="text-muted small">Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, logs.length)} of {logs.length} logs</p>
//           </div>
//           <button onClick={handleExport} className="btn btn-dark rounded-3 shadow-sm px-4">
//             <i className="fas fa-file-download me-2"></i> Export CSV
//           </button>
//         </div>

//         <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
//           <div className="card-body p-0">
//             <div className="table-responsive">
//               <table className="table table-hover align-middle mb-0">
//                 <thead className="bg-light text-muted small text-uppercase">
//                   <tr>
//                     <th className="px-4 py-3">Recipient</th>
//                     <th className="py-3">Message</th>
//                     <th className="py-3">Device</th>
//                     <th className="py-3">Date & Time</th>
//                     <th className="py-3 text-end px-4">Status</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {loading ? (
//                     <tr><td colSpan="5" className="text-center py-5">Loading logs...</td></tr>
//                   ) : currentItems.length === 0 ? (
//                     <tr><td colSpan="5" className="text-center py-5">No messages found.</td></tr>
//                   ) : currentItems.map((log) => (
//                     <tr key={log.id}>
//                       <td className="px-4 fw-semibold">{log.to_number}</td>
//                       <td className="text-muted small">
//                          <div style={{ maxWidth: '250px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
//                             {log.message}
//                          </div>
//                       </td>
//                       <td><span className="badge bg-light text-dark border">{log.device_name}</span></td>
//                       <td className="small">{new Date(log.sent_at).toLocaleString()}</td>
//                       <td className="text-end px-4">
//                         <span className={`badge ${log.status === 'sent' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} rounded-pill`}>
//                           {log.status}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           </div>

//           {/* FRONTEND PAGINATION CONTROLS */}
//           {logs.length > itemsPerPage && (
//             <div className="card-footer bg-white border-0 py-3 px-4 d-flex justify-content-between align-items-center">
//               <button 
//                 className="btn btn-sm btn-outline-secondary rounded-pill px-3"
//                 disabled={currentPage === 1}
//                 onClick={() => setCurrentPage(prev => prev - 1)}
//               >
//                 Previous
//               </button>

//               <div className="d-none d-md-flex gap-2">
//                 {[...Array(totalPages)].map((_, i) => (
//                   <button 
//                     key={i + 1}
//                     onClick={() => setCurrentPage(i + 1)}
//                     className={`btn btn-sm rounded-circle ${currentPage === i + 1 ? 'btn-primary' : 'btn-light'}`}
//                     style={{ width: '32px', height: '32px', padding: 0 }}
//                   >
//                     {i + 1}
//                   </button>
//                 ))}
//               </div>

//               <button 
//                 className="btn btn-sm btn-outline-secondary rounded-pill px-3"
//                 disabled={currentPage === totalPages}
//                 onClick={() => setCurrentPage(prev => prev + 1)}
//               >
//                 Next
//               </button>
//             </div>
//           )}
//         </div>
//       </PageTransition>
//     </Layout>
//   );
// }


import { useEffect, useState } from 'react';
import Layout from '../layout/Layout';
import PageTransition from '../components/PageTransition';
import { getMessageLogs } from '../components/DbServices';
import { getStoredUser } from '../utilities/encryption';
import Swal from 'sweetalert2';

export default function Reports() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5; 

  const user = getStoredUser();
  const userId = user?.data?.id;

  useEffect(() => {
    const fetchReports = async () => {
      setLoading(true);
      const res = await getMessageLogs(userId);
      if (res.status === 200) setLogs(res.data || []);
      setLoading(false);
    };
    fetchReports();
  }, [userId]);

  // Pagination Logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = logs.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(logs.length / itemsPerPage);

  const handleExport = () => {
    Swal.fire("Compiling secure CSV report...");
  };

  // Quick Stats Logic
  const totalSent = logs.filter(l => l.status?.toLowerCase() === 'sent').length;
  const totalFailed = logs.filter(l => l.status?.toLowerCase() === 'failed').length;

  return (
    <Layout>
      <PageTransition>
        <div className="container-fluid py-4">
          
          {/* HEADER SECTION */}
          <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-4 gap-3">
            <div>
              <h3 className="fw-bold mb-1"><span className="color-theme">Message Insights</span> 📊</h3>
              <p className="text-muted small fw-medium">Analytical overview of your WhatsApp communication.</p>
            </div>
            <button 
              onClick={handleExport} 
              className="btn btn-dark rounded-pill shadow-sm px-4 fw-bold border-0"
              style={{ backgroundColor: '#1e293b' }}
            >
              <i className="bi bi-cloud-download me-2"></i> Export Data
            </button>
          </div>

          {/* QUICK STATS CARDS */}
          <div className="row g-3 mb-4">
            <div className="col-md-4">
              <div className="card border-0 shadow-sm rounded-4 p-3 bg-white">
                <div className="d-flex align-items-center gap-3">
                  <div className="rounded-4 bg-indigo-subtle text-indigo p-3"><i className="bi bi-chat-left-dots fs-4"></i></div>
                  <div>
                    <h6 className="text-muted mb-0 small uppercase-tracking fw-bold">Total Processed</h6>
                    <h4 className="fw-black mb-0">{logs.length}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-sm rounded-4 p-3 bg-white border-start border-success border-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="rounded-4 bg-success-subtle text-success p-3"><i className="bi bi-check-all fs-4"></i></div>
                  <div>
                    <h6 className="text-muted mb-0 small uppercase-tracking fw-bold">Successfully Sent</h6>
                    <h4 className="fw-black mb-0">{totalSent}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-4">
              <div className="card border-0 shadow-sm rounded-4 p-3 bg-white border-start border-danger border-4">
                <div className="d-flex align-items-center gap-3">
                  <div className="rounded-4 bg-danger-subtle text-danger p-3"><i className="bi bi-exclamation-triangle fs-4"></i></div>
                  <div>
                    <h6 className="text-muted mb-0 small uppercase-tracking fw-bold">Failed / Pending</h6>
                    <h4 className="fw-black mb-0">{totalFailed}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* MAIN LOGS TABLE */}
          <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
            <div className="table-responsive">
              <table className="table table-hover align-middle mb-0 custom-admin-table">
                <thead style={{ backgroundColor: '#f8fafc' }}>
                  <tr className="text-muted small text-uppercase fw-bold">
                    <th className="ps-4 py-4">Recipient</th>
                    <th className="py-4">Message Content</th>
                    <th className="py-4">Source Instance</th>
                    <th className="py-4">Timestamp</th>
                    <th className="pe-4 py-4 text-end">Delivery Status</th>
                  </tr>
                </thead>
                <tbody>
                  {loading ? (
                    <tr><td colSpan="5" className="text-center py-5"><div className="spinner-border text-primary border-2"></div></td></tr>
                  ) : currentItems.length === 0 ? (
                    <tr><td colSpan="5" className="text-center py-5 text-muted">No communication history found.</td></tr>
                  ) : currentItems.map((log) => (
                    <tr key={log.id} className="border-bottom border-light">
                      <td className="ps-4 py-3">
                        <div className="d-flex align-items-center gap-2">
                          <div className="bg-light rounded-circle p-2 text-primary" style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            <i className="bi bi-person-fill small"></i>
                          </div>
                          <span className="fw-bold text-dark small">+{log.to_number}</span>
                        </div>
                      </td>
                      <td>
                         <div className="text-muted small" style={{ maxWidth: '250px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={log.message}>
                            {log.message}
                         </div>
                      </td>
                      <td>
                        <span className="badge bg-light text-indigo border border-indigo-subtle px-2 py-1" style={{ fontSize: '11px' }}>
                          <i className="bi bi-hdd-network me-1"></i> {log.device_name}
                        </span>
                      </td>
                      <td>
                        <div className="small text-muted fw-medium">
                          {new Date(log.sent_at).toLocaleDateString()} <span className="mx-1 text-silver">|</span> {new Date(log.sent_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                        </div>
                      </td>
                      <td className="pe-4 text-end">
                        <span className={`badge rounded-pill fw-bold ${log.status === 'sent' ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'} px-3 py-2`} style={{ fontSize: '10px' }}>
                          <span className={`pulse-dot me-2 ${log.status === 'sent' ? 'bg-success' : 'bg-danger'}`}></span>
                          {log.status?.toUpperCase()}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          {/* MODERN PAGINATION */}
          {!loading && totalPages > 1 && (
            <div className="d-flex justify-content-between align-items-center mt-4 px-2">
              <p className="text-muted small mb-0">Showing <strong>{indexOfFirstItem + 1}-{Math.min(indexOfLastItem, logs.length)}</strong> of {logs.length}</p>
              <nav>
                <ul className="pagination pagination-sm mb-0 gap-1">
                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link border-0 rounded-pill px-3 shadow-sm" onClick={() => setCurrentPage(prev => prev - 1)}>Prev</button>
                  </li>
                  {[...Array(totalPages)].map((_, i) => {
                    // Show only first few and last few pages if totalPages is large
                    if (totalPages > 5 && i !== 0 && i !== totalPages - 1 && Math.abs(i + 1 - currentPage) > 1) {
                        if (i + 1 === currentPage - 2 || i + 1 === currentPage + 2) return <span key={i} className="px-1 text-muted">...</span>;
                        return null;
                    }
                    return (
                      <li key={i} className={`page-item ${currentPage === i + 1 ? 'active' : ''}`}>
                        <button 
                          className={`page-link border-0 rounded-circle mx-1 ${currentPage === i + 1 ? 'shadow-sm' : ''}`} 
                          style={{ width: '32px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                          onClick={() => setCurrentPage(i + 1)}
                        >
                          {i + 1}
                        </button>
                      </li>
                    );
                  })}
                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link border-0 rounded-pill px-3 shadow-sm" onClick={() => setCurrentPage(prev => prev + 1)}>Next</button>
                  </li>
                </ul>
              </nav>
            </div>
          )}
        </div>
      </PageTransition>
    </Layout>
  );
}